import { FilterValue } from '../../filterValue';
import { SettingKeys } from '../settingDefinitions';
import { define } from './_common';

export const FilterableScaleSetting = define({
    filtersToSetting: (filter, { currentDefinitions }) => {
        if (filter.item !== SettingKeys.SCALE || !FilterValue.is.SCALE(filter.value)) return null;

        const scaleKey = filter.value.value.key;

        // if scale filter value is not selectable in the setting itself,
        // ignore the filter
        const isScaleValueAvailable =
            !currentDefinitions.SCALE ||
            currentDefinitions.SCALE.options.some(({ key }) => key === scaleKey);

        return isScaleValueAvailable ? { SCALE: scaleKey } : null;
    },
});
